export default __webpack_public_path__ + "static/media/feature-approval.9611d0ae.png";